(ns motorsaif.web.layout
  (:require
   ["react" :as react]
   ["react-toastify" :as toast]
   ["react-transition-group" :refer [CSSTransition]]
   [clojure.string :as str]
   [goog.events.EventType :as event-type]
   [goog.functions :refer [debounce]]
   [motorsaif.frontend-routes :as routes]
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.time :as time]
   [motorsaif.utils :as utils]

   [motorsaif.web.admin.entity :as admin-entity]
   [motorsaif.web.admin.home :as admin-home]
   [motorsaif.web.admin.localization :as admin-localization]
   [motorsaif.web.admin.table :as admin-table]

   [motorsaif.web.components :as c]
   [motorsaif.web.components.side-menu :as side-menu]

   [motorsaif.web.pages.dashboard.requests.chat :as dash-request-chat]
   [motorsaif.web.pages.dashboard.requests.index :as dash-requests]
   [motorsaif.web.pages.dashboard.requests.show :as dash-request]

   [motorsaif.web.pages.business-sign-up :as business-sign-up]
   [motorsaif.web.pages.edit-request :as edit-request]
   [motorsaif.web.pages.feed :as feed]
   [motorsaif.web.pages.forgot-password :as forgot-password]
   [motorsaif.web.pages.generic :as generic]
   [motorsaif.web.pages.home :as home]
   [motorsaif.web.pages.login :as login]
   [motorsaif.web.pages.new-business :as new-business]
   [motorsaif.web.pages.new-request :as new-request]

   [motorsaif.web.pages.ops.index :as ops]
   [motorsaif.web.pages.ops.show :as ops-category]
   [motorsaif.web.pages.ops.chat :as ops-chat]

   [motorsaif.web.pages.personal-sign-up :as personal-sign-up]
   [motorsaif.web.pages.public-profile :as public-profile]
   [motorsaif.web.pages.request :as request]
   [motorsaif.web.pages.sign-up :as sign-up]
   [motorsaif.web.pages.verify-code :as verify-code]

   [motorsaif.web.pwa :as pwa]

   [motorsaif.web.pages.settings.business :as settings-business-profile]
   [motorsaif.web.pages.settings.notifications :as settings-notifications]
   [motorsaif.web.pages.settings.personal :as settings-profile]

   [motorsaif.web.svg :as svg]
   [re-frame.core :as rf :refer [dispatch subscribe]]
   [reagent.core :as r]))

(defn is-pwa? []
  (.-matches (js/window.matchMedia "(display-mode: standalone)")))

(defn unread [c]
  (let [*last-c (r/atom 0)
        *c (r/atom 0)
        set-c (debounce (fn [c]
                          (when (> c 0)
                            (reset! *last-c c))
                          (reset! *c c)) 1000)]
    (fn [c]
      (set-c c)
      [:> CSSTransition
       {:timeout 400
        :unmount-on-exit true
        :class-names "fade"
        :in (> @*c 0)}
       [:span.unread.if-c
        (if (= c 0)
          @*last-c
          c)]])))

(defn messages-nav []
  (let [total-msg-count @(subscribe [:total-unread-msgs])]
    [:div.msgs
     [:span.title
      "Requests"]
     [unread total-msg-count]]))
;; (utils/set-root-property :second-color "red")

(defn main-nav []
  (let [

        *user (subscribe [:current-owner-id])
        ref (react/createRef)
        ]
    (r/create-class
      {:component-did-mount
       (fn []
         (utils/set-root-property :nav-height
                                  (str (.-clientHeight (.-current ref)) "px")))
       :reagent-render
       (fn []
         (let [is-business? @(rf/subscribe [:is-business?])
               active (:nav (:data @(rf/subscribe [:route/data])))
               logged-in [[:feed
                           [:i.fal.fa-house-blank]
                           (tr :nav.home)]
                          (when is-business?
                            [:ops
                             [:i.fal.fa-briefcase]
                             "Operations"])
                          [:dash-requests
                           [:i.fal.fa-message-lines]
                           [messages-nav]]
                          [:new-request
                           [:i.fal.fa-plus]
                           (tr :nav.new-request)]]
               logged-out [[:home
                            [:i.fal.fa-house-blank]
                            (tr :nav.welcome)]
                           [:feed
                            [:i.fal.fa-list]
                            (tr :nav.preview)]
                           [:sign-up
                            [:i.fal.fa-plus]
                            (tr :nav.register)]]
               nav-items (if @*user logged-in logged-out)]
           [:nav.main
            {:ref ref}
            [:ul
             {:class
              (utils/cond-css
               @*user "signed-in"
               is-business? "business")}
             (for [[k icon title] (remove nil? nav-items)]
               ^{:key k}
               [:li
                {:class
                 (str (name k)
                      (when (= active k) " active"))}
                [:a
                 {:href (routes/path-for k)
                  :class (name k)}
                 icon
                 [:span title]]])]]))})))

(def modal-k->renderer
  {:role-selector
   (fn [] [c/role-modal])})

(defn modal-inner [{:keys [modal-key renderer class]}]
  (let [id (gensym "modal")
        outside-click
        #(utils/on-click-outside-element
          {:element-id id
           :on-outside-click
           (fn []
             (dispatch [:assoc-data :modal nil]))})

        renderer (or renderer
                     (get modal-k->renderer modal-key))]
    (outside-click)
    (assert renderer (str [:no-modal
                           :r renderer
                           :k modal-key]))
    (r/create-class
      {:component-did-mount
       (fn []
         (.add (.-classList js/document.documentElement) "modal-active")
         (outside-click))
       :component-will-unmount
       (fn []
         (.remove (.-classList js/document.documentElement) "modal-active"))
       :reagent-render
       (fn []
         [:div#modal
          {:class class}
          [:div.content
           {:id id}
           [:button.btn.close
            {:on-click #(dispatch [:assoc-data :modal nil])}
            [:i.fas.fa-times]]
           [renderer]]])})))

(defn login-google [req]
  (let [qp (:query-params @(rf/subscribe [:route/data]))
        {:keys [code]} qp]
    (rf/dispatch [:login-google code])
    [:div.login-container
     [:div.login-content
      [:h2.login-title "Signing you in"]
      [:p.login-subtitle "Just a moment..."]]]))

(defn modal-container []
  (let [*modal (subscribe [:modal])]
    (fn []
      (when-let [modal @*modal]
        [modal-inner modal]))))

(defn ios-homebar? []
  (not= (.getPropertyValue (js/getComputedStyle js/document.documentElement) "--sab") "0px"))

(def *scroll-info (r/atom {:feed {:last-top 0}}))
(def *page (r/atom nil))
(def *vis-counter (r/atom [[:init (time/stamp)]]))


(defn layout []
  (let [is-ios?      utils/is-ios?
        on-scroll-fn (fn [dom e]
                       (let [st (.-scrollTop dom)]
                         ;; Quick hack to avoid setting top to 0 on feed

                         (swap! *scroll-info update-in [@*page :last-top]
                                (fn [old]
                                  (if (= st 0)
                                    old
                                    st)))))

        *scroll-targ (atom nil)
        set-scroll   (fn [top]
                     (when (and @*scroll-targ top)
                       (.scrollTo @*scroll-targ 0 top)))

        page-vis-fn
        (fn [e]
          (swap! *vis-counter conj [:add
                                    js/document.hidden
                                    (time/stamp)]))
        *breakpoint (subscribe [:breakpoint])
        *route-data (rf/subscribe [:route/data])
        *side-menu  (r/atom true)]

    (utils/register-event :page-visibility js/document
                          (clj->js ["visibilitychange" "blur" "focus" "resume" "pageshow"])
                          page-vis-fn)

    (fn []
      (when-let [page @(rf/subscribe [:route/page])]
        [:div#page.scroll
         {:class (str/join " " (-> [(str (name page) "")]
                                   (cond-> is-ios?
                                     (conj "ios")
                                     (ios-homebar?)
                                     (conj "ios-homebar"))))}

         (when-not @(subscribe [:ws-open?])
           [:div#is-offline
            [:span.wrap
             (tr [:general.offline])]])

         [(r/adapt-react-class (.-ToastContainer toast))
          {:autoClose 5000}]

         [pwa/install-notification]
         [modal-container]

         ^{:key (str (:db/id @(subscribe [:current-owner])))}
         [:div#page-grid
          (-> {:class
               (-> [(name @(subscribe [:breakpoint]))]
                   (cond-> (:nav (:data @*route-data))
                     (conj "nav-visible"))
                   (->> (str/join " ")))})

          [:div#page-wrap
           (-> {:ref (fn [dom]
                       (when dom
                         (reset! *scroll-targ dom)
                         (reset! *page page)
                         (utils/register-event :layout-scroll dom
                                               event-type/SCROLL
                                               #(on-scroll-fn dom %))))})
           (condp = page
             :home             [home/root]
             :sign-up          [sign-up/root]
             :personal-sign-up [personal-sign-up/root]
             :business-sign-up [business-sign-up/root]
             :login            [login/root]
             :forgot-password  [forgot-password/root]
             :feed             [feed/root
                                {:after-mount #(set-scroll
                                                (get-in @*scroll-info [page :last-top]))}]

             :request      [request/root]
             :new-request  [new-request/root]
             :login-google [login-google]

             :public-profile [public-profile/root]
             :verify-code    [verify-code/root]

             :ops          [ops/root]
             :ops-category [ops-category/root]
             :ops-chat     [ops-chat/root]

             :dash-requests     [dash-requests/root]
             :dash-request      [dash-request/root]
             :dash-request-chat [dash-request-chat/root]
             :dash-edit-request [edit-request/root]

             :settings-notifications    [settings-notifications/root]
             :settings-profile          [settings-profile/root]
             :settings-business [settings-business-profile/root]

             ;; GENERIC
             :generic
             [:div#generic
              (condp = (:name (:data @*route-data))
                :terms      [generic/terms]
                :privacy    [generic/privacy]
                :about      [generic/about]
                :businesses [generic/businesses])]

             ;; ADMIN

             :admin              [admin-home/root]
             :admin-localization [admin-localization/root]
             :admin-table        [admin-table/root]
             :admin-entity       [admin-entity/root]
             :admin-new-entity   [new-business/root]

             [:div.container
              [:div
               [:h1 (tr :page.not-found)]
               [:p (str [:page page
                         (dissoc (:data @*route-data) :coercion :controllers)])
                ]]])]]]))))

(defn mobile []
  (let [*side-menu (subscribe [:ui-state :side-menu-open])]
    (fn []
      (let [hide-mobile-nav? (get-in @(rf/subscribe [:route/data]) [:data :hide-mobile-nav])]
        [:div#mobile
         {:class
          (utils/cond-css
           @*side-menu "blur"
           hide-mobile-nav? "hide-nav")}
         [layout]
         [side-menu/side-menu]
         (when-not hide-mobile-nav?
           [main-nav])]))))

(defn desktop []
  [:div#desktop
   (when-not (= @(rf/subscribe [:route/page]) :home)
     [:div#sidebar
      [:div.logo
       [:a {:href "/"}
        svg/logo]]
      [side-menu/side-menu]
      [main-nav]])
   [layout]])

(defn main []
  (when @(subscribe [:all-ajax-loaded? :bootstrap-data])
    (if (= :desktop @(subscribe [:breakpoint]))
      [desktop]
      [mobile])))

;; ClojureScript/Reagent Component



;; (require 'sc.api)

;; (def my-fn
;;   (let [a 23
;;         b (+ a 3)]
;;     (fn [x y z]
;;       (let [u (inc x)
;;             v (+ y z u)]
;;         (* (+ x u a)
;;           ;; Insert a `spy` call in the scope of these locals
;;           (sc.api/spy
;;             (- v b)))
;;         ))))

;; (my-fn 3 5 5)
;; (sc.api/defsc [17 -4])


;; ;; ;; NOTE does not work here in mobile build
;; (comment
;;   (require '[sc.api :as sca]))




;; (def my-fn
;;   (let [a 23
;;         b (+ a 3)]
;;     (fn [x y z]
;;       (let [u (inc x)
;;             v (+ y z u)]
;;         (* (+ x u a)
;;           ;; Insert a `spy` call in the scope of these locals
;;           (sca/spyqt
;;             (- v b)))
;;         ))))


;; (my-fn 3 5 5)
;; (try
;;     (ns-name *ns*)
;;     (catch js/Error e (str "Namespace error: " e)))

;; (sc.api/defsc [17 -4])
